import Button from '@mui/material/Button';
import { Snackbar as MUISnackbar, SnackbarCloseReason } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import React, { Fragment, useState } from 'react';
import { enqueueSnackbar, SnackbarProvider } from 'notistack';
import { snackVar } from '@src/constants/snack';
import useReactiveVar from '@utils/makeReactiveVar';
import { useLocale } from '../../../i18n/LocaleContext';

const Snackbar = () => {
  const { t } = useLocale();
  const [open, setOpen] = useState(false);
  const snack = useReactiveVar(snackVar).get();

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const action = (
    <Fragment>
      <Button color="secondary" size="small" onClick={handleClose}>
        {t('common.undo')}
      </Button>
      <IconButton size="small" aria-label={t('common.close')} color="inherit" onClick={handleClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Fragment>
  );

  return (
    <SnackbarProvider maxSnack={3}>
      <MUISnackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={t('common.archived')}
        action={action}
      />
    </SnackbarProvider>
  );
};

export default Snackbar;
